import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { logIn } from "../../utils/login";
import { useToasts } from "react-toast-notifications";
import "../../style/Login.css";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [redirect, setRedirect] = useState(false);
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const handleSubmit = (event) => {
    event.preventDefault();

    axios
      .post(`${API_URL}/api/auth/login`, { username, password })
      .then((res) => {
        if (res.status === 200) {
          logIn(res.data.token);
          dispatch({ type: "LOGIN" });
          addToast(`${res.data.message}`, {
            appearance: "success",
            autoDismiss: true,
          });
          setRedirect(true);
        }
      })
      .catch((err) =>
        addToast(`${err.response.data.message}`, {
          appearance: "error",
          autoDismiss: true,
        })
      );
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Connexion</title>
      </Helmet>
      {redirect && <Redirect to="/" />}
      <form onSubmit={handleSubmit}>
        <div className="loginContainer">
          <div className="loginContainer2">
            <h1>Connexion</h1>
            <input
              type="text"
              placeholder="Identifiant ou adresse mail"
              value={username}
              onChange={(event) => {
                setUsername(event.target.value);
              }}
              required
            />
            <input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              required
            />
            <button
              type="submit"
              className="btn button-envoyer"
              value="Se connecter"
            >
              Se connecter
            </button>
          </div>
          {/**<span className="loginSpan">
            <Link to={"signup"}>Créer un compte</Link> -{" "}
            <Link to={"reset-mdp"}>Mot de passe oublié</Link>
          </span>**/}
        </div>
      </form>
    </div>
  );
}

export default Login;
